import { useEffect, useState } from 'react';
import { Control, useForm } from 'react-hook-form';

import { useEmailValidateUserMutation } from 'api/mutations/useEmailValidateUserMutation';
import { COMPANY_NAME_IS_USED, EMAIL_IS_USED } from 'constants/errorCodes';
import { ApiErrors, CompanyInfoFormValues, CompanyPersonalDataFormValues } from 'types';

export type RegisterCompanyFormValues = CompanyPersonalDataFormValues & CompanyInfoFormValues;

interface UseRegisterCompanyFormReturn {
  handleFormSubmit: () => void;
  control: Control<RegisterCompanyFormValues>;
  passwordHide: boolean;
  emailValidationMutation: ReturnType<
    typeof useEmailValidateUserMutation
  >['emailValidationMutation'];
}

interface UseRegisterCompanyFormProps {
  defaultValues: RegisterCompanyFormValues;
  handleRegisterSubmit: (data: RegisterCompanyFormValues) => void;
  errors?: Record<string, ApiErrors['errors']> | null;
}

export function useRegisterCompanyForm({
  defaultValues,
  handleRegisterSubmit,
  errors,
}: UseRegisterCompanyFormProps): UseRegisterCompanyFormReturn {
  const { handleSubmit, control, setError } = useForm<RegisterCompanyFormValues>({
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });
  const [passwordHide, setPasswordHide] = useState<boolean>(true);
  const { emailValidationMutation } = useEmailValidateUserMutation({ setPasswordHide });

  useEffect(() => {
    if (Boolean(errors && errors[EMAIL_IS_USED])) {
      setError('email', { message: '' });
    }

    if (Boolean(errors && errors[COMPANY_NAME_IS_USED])) {
      setError('companyName', { message: '' });
    }
  }, [errors, setError]);

  const handleFormSubmit = handleSubmit((data) => {
    handleRegisterSubmit(data);
  });

  return { handleFormSubmit, control, passwordHide, emailValidationMutation };
}
